// UI팀 z-index 토큰(공통문서 U1)이 노출되기 전까지의 임시 표준.
// 값 자체보다 "파일마다 제각각인 매직넘버를 없앤다"가 목적이므로, U1 완료 시 이 상수들을
// 토큰 유틸 호출로 일괄 치환한다(참고: docs/UI_GAP/인디플래너_UI표준_Gap_분석.md A1/B1).
export const Z_POPUP        = 900  // 1차 팝업/모달 오버레이(확인창·대형 콘텐츠 팝업 공통)
export const Z_CONTEXT_MENU = 1000 // 컨텍스트 메뉴, 메모 툴팁 등 캔버스 위 떠다니는 UI
export const Z_ONBOARDING   = 1050 // 화면 가이드(스포트라이트 투어) — 팝업·컨텍스트메뉴 위, 토스트 아래
export const Z_TOAST        = 1100 // 토스트(항상 최상단)
